<!--<c-footer>-->
<!-- <div class="text-white">
    <a href="#0" class="text-white">Public Health Care</a>
    <span> &copy; Abu Dhabi</span>
  </div> -->

<div class="news-ticker">
  <div class="ticker-head">
    <p>Alert:</p>
  </div>
  <div class="ticker-body" id="ticker">
    <p>
      03 July 2023 Siasat Policies Automation Portal Launch. The portal is
      available to sectors/offices/centers at DOH Policies.
    </p>
    <p>03 July 2023 Tableegh Portal. Coming Soon!!!</p>
  </div>
</div>
<!-- <div class="ms-auto">
    Powered by
    <a href="#0">
      <span> CoreUI for Angular</span>
    </a>
  </div> -->
<!--</c-footer>-->
